document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('[data-faq-section]');
  if (!section) return;

  const tabs = [...section.querySelectorAll('[data-faq-tab]')];
  const panels = [...section.querySelectorAll('[data-faq-panel]')];

  if (!tabs.length || !panels.length) return;

  const activateTab = (tabId) => {
    tabs.forEach((tab) => tab.classList.remove('is-active'));
    panels.forEach((panel) => panel.classList.remove('is-active'));

    const activeTab = tabs.find((tab) => tab.dataset.faqTab === tabId);
    const activePanel = panels.find((panel) => panel.dataset.faqPanel === tabId);

    activeTab?.classList.add('is-active');
    activePanel?.classList.add('is-active');
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      activateTab(tab.dataset.faqTab);
    });

    tab.addEventListener('mouseenter', () => {
      if (!tab.classList.contains('is-active')) {
        tab.classList.add('is-hovered');
      }
    });

    tab.addEventListener('mouseleave', () => {
      tab.classList.remove('is-hovered');
    });
  });
});
